__turbopack_context__.v({
  "brandWrap": "Footer-module-scss-module__UYniKq__brandWrap",
  "businessInfo": "Footer-module-scss-module__UYniKq__businessInfo",
  "copy": "Footer-module-scss-module__UYniKq__copy",
  "footer": "Footer-module-scss-module__UYniKq__footer",
  "fullLine": "Footer-module-scss-module__UYniKq__fullLine",
  "inner": "Footer-module-scss-module__UYniKq__inner",
  "links": "Footer-module-scss-module__UYniKq__links",
  "logoImg": "Footer-module-scss-module__UYniKq__logoImg",
  "main": "Footer-module-scss-module__UYniKq__main",
  "mainRight": "Footer-module-scss-module__UYniKq__mainRight",
  "noticeBtn": "Footer-module-scss-module__UYniKq__noticeBtn",
});
